
import { useContext, useState } from "react";
import BusinessContext from "../../contexts/business";

import * as api from "../../api";
import Button from "../../components/atoms/Button";
import { Checkbox, Dialog, DialogBody, DialogFooter } from "@blueprintjs/core";
import { AppToaster } from "../../toaster";
import RichTextEditor from "../../components/organisms/RichTextEditor";

const styles = {
	acceptDeclineButtons: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "center",
		gap: 10,
	},
	enableTermsContainer: {
		display: "flex",
		flexDirection: "row",
		gap: 6,
		alignItems: "center"
	},
	acceptDeclineCheckboxText: {
		paddingRight: 16,
	},
	acceptDeclineContainer: {
		minHeight: "27vh",
		paddingTop: 25,
		paddingHorizontal: 10,
		gap: 15,
	},
	bold: {
		fontWeight: "600",
	},
	button: {
		height: 50,
	},
	container: {
		backgroundColor: "white",
	},
	contentContainer: {
		display: "flex",
		gap: 15,
		paddingHorizontal: 12,
		paddingBottom: 50,
		paddingTop: 30,
		backgroundColor: "rgba(221, 224, 229, 0.2)",
	},
	link: {
		color: "rgba(0, 35, 91, 0.7)",
		textDecorationLine: "underline",
	},
	outerButton: {
		// width: "47%",
	},
	pageContainer: {
		height: "100vh",
		justifyContent: "space-between",
	},
	title: {
		fontSize: 18,
		textAlign: "center",
		fontWeight: "600",
		padding: 12,
	},
};

const Title = () => {
	return (
		<p style={styles.title as any}>
			Enable terms and conditions
		</p>
	);
};

const PaymentTermsOfUseDialog = ({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) => {
	const { business, mutate } = useContext(BusinessContext);
	const [termsAndConditions, setTermsAndConditions] = useState(business?.termsAndConditions ?? "");
	const [readTerms, setReadTerms] = useState(business?.enableTermsAndConditions);
	const [submitting, setSubmitting] = useState(false);

	const toggleTerms = () => {
		setReadTerms((terms) => !terms);
	};

	const businessPayload = {
		enable_terms_and_conditions: readTerms,
		terms_and_conditions: termsAndConditions
	};

	const updateBusiness = async () => {
		setSubmitting(true);

		try {
			await api.business.updateMyBusiness(businessPayload);
			mutate();

			AppToaster.show({
				message: "Terms and Conditions saved successfully",
				intent: "success",
			});

			onClose();
		} catch (e: any) {
			AppToaster.show({
				message: e.message,
				intent: "danger",
			});
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Dialog isOpen={isOpen} onClose={onClose}>
			<DialogBody>
				<Title />
				<p style={{ textAlign: "center", fontWeight: "normal" }}>
					You can create terms and conditions that your users will need to accept before booking a service. Remember to <b>enable</b> it below before it can be live.
				</p>
				<RichTextEditor defaultHtml={termsAndConditions} setHtml={setTermsAndConditions} />
			</DialogBody>
			<DialogFooter
				actions={
					<Button
						onClick={updateBusiness}
						disabled={submitting}
						loading={submitting}
						style={styles.outerButton}
						intent={"primary"}
					>
						Save Terms And Conditions
					</Button>
				}
			>
				<div style={styles.enableTermsContainer as any}>
					<Checkbox onChange={toggleTerms} checked={readTerms} style={{ marginBottom: -3 }} />
					<p style={styles.acceptDeclineCheckboxText}>
						Enable Terms and conditions
					</p>
				</div>

			</DialogFooter>
		</Dialog>
	);
};

export default PaymentTermsOfUseDialog;
